// @ts-nocheck
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { api } from '../services/api'
import { useTranslation } from 'react-i18next'

function groupByDay(notifications: any[], locale: string) {
  const groups: { label: string; items: any[] }[] = []
  const today = new Date()
  const yesterday = new Date(today)
  yesterday.setDate(today.getDate() - 1)

  for (const n of notifications) {
    const d = new Date(n.createdAt)
    const isToday = d.toDateString() === today.toDateString()
    const isYesterday = d.toDateString() === yesterday.toDateString()
    const label = isToday ? 'Dnes' : isYesterday ? 'Včera' : d.toLocaleDateString(locale, { day: '2-digit', month: 'long', year: 'numeric' })

    const last = groups[groups.length - 1]
    if (last && last.label === label) {
      last.items.push(n)
    } else {
      groups.push({ label, items: [n] })
    }
  }
  return groups
}

export default function NotificationHistory() {
  const navigate = useNavigate()
  const { t, i18n } = useTranslation()
  const [notifications, setNotifications] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    api.get('/notification-history')
      .then(res => setNotifications(res.data.notifications))
      .catch(() => {})
      .finally(() => setLoading(false))
  }, [])

  function timeAgo(dateStr: string): string {
    const diff = Date.now() - new Date(dateStr).getTime()
    const min = Math.floor(diff / 60000)
    const h = Math.floor(min / 60)
    const d = Math.floor(h / 24)
    if (min < 1) return t('notificationHistory.justNow')
    if (min < 60) return t('notificationHistory.minAgo', { min })
    if (h < 24) return t('notificationHistory.hAgo', { h })
    return t('notificationHistory.dAgo', { d })
  }

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
      <div style={{ backgroundColor: '#fff', borderBottom: '1px solid #f0f0f0' }}>
        <div style={{ maxWidth: 600, margin: '0 auto', padding: '16px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <button style={{ background: 'none', border: 'none', color: '#888', fontSize: 16, cursor: 'pointer', padding: 0 }} onClick={() => navigate(-1)}>{t('notificationHistory.back')}</button>
        </div>
      </div>

      <div style={{ maxWidth: 600, margin: '0 auto', padding: '20px 20px' }}>
        <h2 style={{ fontSize: 20, fontWeight: 700, color: '#1a1a1a', margin: '0 0 20px' }}>🔔 {t('notificationHistory.title')}</h2>

        {loading ? (
          <p style={{ textAlign: 'center', color: '#888' }}>...</p>
        ) : notifications.length === 0 ? (
          <div style={{ textAlign: 'center', paddingTop: 60 }}>
            <div style={{ fontSize: 52, marginBottom: 12 }}>🔕</div>
            <h3 style={{ fontSize: 18, fontWeight: 600, color: '#1a1a1a' }}>{t('notificationHistory.empty')}</h3>
            <p style={{ fontSize: 14, color: '#888' }}>{t('notificationHistory.emptyDesc')}</p>
          </div>
        ) : (
          groupByDay(notifications, i18n.language).map((group) => (
            <div key={group.label}>
              <p style={{ fontSize: 12, fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: 0.8, margin: '20px 0 8px 4px' }}>{group.label}</p>
              {group.items.map((n: any) => (
                <div
                  key={n.id}
                  onClick={() => n.deviceId && navigate(`/device/${n.deviceId}`)}
                  style={{ backgroundColor: '#fff', borderRadius: 14, padding: '14px 18px', marginBottom: 8, boxShadow: '0 2px 10px rgba(0,0,0,0.04)', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12, cursor: n.deviceId ? 'pointer' : 'default' }}
                >
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <p style={{ fontSize: 13, fontWeight: 700, color: '#2D7A3A', margin: '0 0 2px' }}>{n.title}</p>
                    <p style={{ fontSize: 15, color: '#1a1a1a', margin: '0 0 4px', wordBreak: 'break-word' }}>{n.body}</p>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 6, flexShrink: 0 }}>
                    <span style={{ fontSize: 12, color: '#aaa', whiteSpace: 'nowrap' }}>{timeAgo(n.createdAt)}</span>
                    {n.deviceId && (
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#d1d5db" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="9 18 15 12 9 6"/>
                      </svg>
                    )}
                  </div>
                </div>
              ))}
            </div>
          ))
        )}
      </div>
    </div>
  )
}
